import React, { useContext } from 'react';
import { Button, Card } from 'react-bootstrap';
import { ProjectContext } from 'contexts/ProjectContext';

const Home = () => {
  const projectContext = useContext(ProjectContext);
  const currentProject = projectContext?.currentProject;
  // siteUrl — только из project_data.footer_link текущего проекта. Раньше
  // был хардкод 'https://teslapay.eu' — кнопка «Открыть сайт проекта»
  // вела на чужой проект. Сейчас если у проекта footer_link не задан —
  // кнопка просто не рендерится.
  const siteUrl = currentProject?.project_data?.footer_link || '';
  const projectName = currentProject?.name || 'проект';

  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center p-5">
        <h3 className="mb-3">Добро пожаловать в админ-панель</h3>
        <p className="text-muted mb-4">
          Управление проектом <strong>{projectName}</strong>
        </p>
        {siteUrl && (
          <>
            <Button
              variant="primary"
              size="lg"
              href={siteUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Открыть сайт проекта
            </Button>
            <small className="text-muted mt-3">{siteUrl}</small>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default Home;
